module.exports = __webpack_public_path__ + "img/scrying-mirror-3.8cf1aa78.webp";